import { noop } from '@src/utils/utils';
import type { FC, PropsWithChildren } from 'react';

export interface ProgressBarProps extends PropsWithChildren {
    className?: string;
    progress: number; // e.g. 0.2
    onClick: () => void;
    progressFillClasName?: string;
}

const ProgressBar: FC<ProgressBarProps> = props => {
    const { onClick = noop, children, className = '', progress, progressFillClasName = '' } = props;

    const containerClasses = `relative w-full h-8 rounded-lg overflow-hidden transition shadow-sm dark:shadow-sm bg-white dark:bg-gray-950 border border-gray-100 dark:border-gray-700 text-gray-800 dark:text-gray-50 ${className}`;
    const fillClasses = `absolute left-0 top-0 h-full transition-all duration-300 ease rounded-l-lg ${progress === 1 ? 'rounded-r-lg' : ''} ${progressFillClasName}`;

    return (
        <div className={containerClasses} onClick={onClick}>
            <div
                className={fillClasses}
                style={{
                    width: `${progress * 100}%`,
                    transform: progress === 0 ? 'translate3d(-100%, 0, 0)' : 'translate3d(0, 0, 0)',
                }}
            />
            {children}
        </div>
    );
};

export default ProgressBar;
